import { api, handleError, handleResponse } from "./apiServices";
export const change_password = (token, id, data) =>
  api(token)
    .post(`/api/merchant/auth/change-password`, data)
    .then(handleResponse)
    .catch(handleError);

export const getMerchantProfile = (token, id) =>
  api(token)
    .get(`/api/merchant/merchantProfile/viewMerchant/${id}`)
    .then(handleResponse)
    .catch(handleError);

export const forgotPassword = data =>
  api()
    .post("/api/merchant/auth/forget-password", data)
    .then(handleResponse)
    .catch(handleError);
export const editMerchantProfile = (token, id, data) =>
  api(token)
    .post(`/api/merchant/merchantProfile/editMerchant/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
